<template>
  <v-container style="max-width:1280px;">
      <v-row justify="end">
         <v-col md="12" lg="12" sm="12" cols="12" >
            <v-row>
              <v-col cols="12" lg="2" sm="12" class="px-4 dealHeader" ><h2>Sweet Deals</h2></v-col>
              <v-col cols="12" lg="10" sm="12" class="pa-4" style="background: white; margin-top: -20px;">
                <v-tabs center-active color="primary" v-model="activeCoinTab">
                  <v-tab v-for="coin of filters.coins" :key="'tab-' + coin" @click="$store.state.selectedCoins = [coin]">{{coin}}</v-tab>
                  <v-tab-item v-for="coin of filters.coins" :key="'tab-item-' + coin">
                    <coin-summary style="padding: 10px;" :coin="coin" :currency="coin" />
                  </v-tab-item>
               </v-tabs>
              </v-col>
              </v-row>
        </v-col>
      </v-row>
    <v-row justify="center">
      <v-col class="filterPanel" v-if="!$vuetify.breakpoint.xsOnly">
        <div class="mx-3">
          <v-select label="Sort by" :items="filters.sort" v-model="filter.sort" />
        </div>

        <filter-panel v-model="filter.duration" title="Term" :items="filters.durations" format="$$" ga="duration" />
        <filter-panel v-model="filter.issuers" title="Seller" :items="filters.issuers" format="$$" ga="seller" />
        <filter-panel ga="misc" title="Filters" :value="filter" :items="[['Favorites', 'showFavOnly']]" />
      </v-col>
      <v-navigation-drawer v-model="drawer" absolute temporary v-if="$vuetify.breakpoint.xsOnly">
        <filter-panel v-model="filter.duration" title="Duration" :items="filters.durations" format="$$ days" ga="duration" />
        <filter-panel v-model="filter.issuers" title="Seller" :items="filters.issuers" format="$$" ga="seller" />
        <filter-panel ga="misc" title="Filters" :value="filter" :items="[['Favorites', 'showFavOnly']]" />
      </v-navigation-drawer>
      <v-col class="filterPanel d-flex align-center" v-if="$vuetify.breakpoint.xsOnly">
        <v-app-bar-nav-icon @click.stop="drawer = !drawer" />
        <div class="mx-3 flex-grow-1">
          <v-select label="Sort by" :items="filters.sort" v-model="filter.sort" />
        </div>
      </v-col>

      <v-col md="10" lg="10" sm="12" cols="12">
         <v-row justify="space-between" align-content="center" class="caption d-none d-sm-flex" style="margin: 0">
           <v-col cols="3">Contract Name</v-col>
           <v-col cols="2">
             <v-menu offset-y>
               <template v-slot:activator="{ on }">
                   {{slot1[0]}}{{slot1[1]}}
                   <v-icon v-on="on" class="body-1 mx-1">mdi-arrow-down-drop-circle-outline</v-icon>
               </template>
               <v-list>
                 <v-list-item v-for="([title], idx) of slot1Menu"
                              :key="title"
                              @click="$store.commit('product/selectSlot', { slot: 1, idx })"
                 >
                   <v-list-item-title>{{title}}</v-list-item-title>
                 </v-list-item>
               </v-list>
             </v-menu>
           </v-col>
           <v-col cols="2" v-if="$vuetify.breakpoint.lg" />
           <v-col cols="2" v-if="!$vuetify.breakpoint.lg" />
           <v-menu offset-y>
             <template v-slot:activator="{ on }">
               <v-col cols="2">
                 <span style="margin-left: 10px;">{{slot2[0]}}</span>
                 <v-icon v-on="on" class="body-1 mx-1">mdi-arrow-down-drop-circle-outline</v-icon>
               </v-col>
             </template>
             <v-list>
               <v-list-item v-for="([title], idx) of slot2Menu"
                            :key="title"
                            @click="$store.commit('product/selectSlot', { slot: 2, idx })"
               >
                 <v-list-item-title>{{title}}</v-list-item-title>
               </v-list-item>
             </v-list>
           </v-menu>
          
           <v-col cols="3" />
        </v-row>
<!--        <div class="productContainer">-->
          <cloud-mining-card v-for="(item, index) in products.slice(0, 10)" :idx="index" :key="index" :item="item" />
          <v-lazy v-for="(item, index) in products.slice(10)" :key="index + 10">
            <cloud-mining-card :item="item" />
          </v-lazy>
<!--        </div>-->
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState, mapGetters } from "vuex";

import { getDurationAlias } from "@/api/contract/cloud-mining";
import { price, unit, hashrate, totalReward } from "../filters";

import { coins } from "@/api/const";

import CoinSummary from "@/components/CoinSummary";
import CloudMiningCard from "@/components/product/CloudMiningCard";
import FilterPanel from "@/components/FilterPanel";

export default {
  name: "Products",
  filters: { price, unit, hashrate, totalReward },
  components: { CoinSummary, CloudMiningCard, FilterPanel },
  watch: {
    '$store.state.selectedCoins'() {
      this.filter.duration.splice(0);
      this.filter.issuers.splice(0);
    }
  },
  computed: {
    ...mapGetters("cloudMining", ["findContract"]),
    ...mapState("product", ["currency", "slot1", "slot2", "slot1Menu", "slot2Menu"]),
    ...mapState(["selectedCoins", "favorites", "summary", "blockchain"]),
    filters() {
      const products = this.findContract(this.selectedCoins[0]);

      const durationSet = new Set();
      const filters = products.reduce(
        (m, v) => {
          if (!durationSet.has(v.durationAlias)) {
            durationSet.add(v.durationAlias);
            m.durations.push([v.duration, v.durationAlias]);
          }

          if (m.issuers.indexOf(v.issuer) < 0) m.issuers.push(v.issuer);
          return m;
        },
        {
          durations: [],
          issuers: [],
          coins: this.coins,
          sort: [
            {
              text: "↓ ROI",
              value: { field: item => item.total.roi, order: "desc", id: "roi" }
            },
            {
              text: "↑ Unit price",
              value: { field: item => item.daily.preHalving.cost, order: "asc", id: "unit-price" }
            },
            {
              text: "↑ Upfront fees",
              value: { field: item => item.total.upfront, order: "asc", id: "upfront" }
            }
          ]
        }
      );

      filters.durations = filters.durations.sort((a, b) => a[0] - b[0]).map(v => v[1]);
      return filters;
    },
    products() {
      const products = this.findContract(this.selectedCoins[0]);

      const res = products.filter(
        v =>
          (!this.filter.showFavOnly || this.favorites.indexOf(v.id) >= 0) &&
          // (!this.filter.showInStockOnly || v.sold_percent < 100) &&
          (this.filter.issuers.length === 0 ||
            this.filter.issuers.indexOf(v.issuer) >= 0) &&
          (this.filter.duration.length === 0 ||
            this.filter.duration.indexOf(v.durationAlias) >= 0)
      );

      const maxRoi = Math.max(...res.map(v => v.total.roi));
      res.forEach(v => v.isBestDeal = v.total.roi === maxRoi);

      if (this.filter.sort) {
        const { field, order } = this.filter.sort;
        res.sort((a, b) => {
          const fa = a[field] || field(a);
          const fb = b[field] || field(b);
          return order === "asc" ? fa - fb : fb - fa;
        });
      }

      return res;
    }
  },
  data() {
    const { coin, duration } = this.$route.query;
    if (coin) this.$store.state.selectedCoins = [coin];

    return {
      coins,
      csel: 0,
      drawer: false,
      activeCoinTab: coins.indexOf(coin || this.$store.state.selectedCoins[0]),
      filter: {
        duration: duration ? [getDurationAlias(duration * 1)] : [],
        issuers: [],
        sort: { field: item => item.total.roi, order: "desc", id: "roi" },
        showFavOnly: false,
        showInStockOnly: false
      }
    };
  }
};
</script>

<style scoped lang="scss">
.v-item--active {
  color: #222;
  background-color: #ffe500 !important;
}

.v-card{
  box-shadow: 
      0px 0px 5px 1px rgba(0, 0, 0, 0.2), 
      0px 2px 2px 0px rgba(0, 0, 0, 0.14), 
      0px 1px 5px 0px rgba(0, 0, 0, 0.12)
}

.v-card--hover:hover {
  -webkit-box-shadow: 0px 0px 0px 2px rgba(255, 229, 0, 0.8),
    0px 2px 2px 2px rgba(251, 255, 0, 0.2);
  box-shadow: 0px 0px 0px 2px rgba(255, 229, 0, 0.8),
    0px 2px 2px 2px rgba(251, 255, 0, 0.2);
}


.filterPanel {
  width: 80px;
  .v-card {
    background: transparent;
  }
  @media (max-width: 960px) {

    &-coin {
      display: none;
    }


  }
}

.dealHeader{
   text-align: center;
   padding-top: 40px;
   @media (max-width: 1200px) {
     padding-top:0;
   }
}

@media only screen and (max-width: 500px) {
  .filterPanel {
    padding: 0 12px;
  }

  .filterPanel .v-card__text {
    padding:0;
  }

  .mdi-help-circle-outline {
    display: none;
  }
  .dealHeader
  {
    display: none;
  }

  .tableHeader{
      flex-direction: column;
  }
  .headerNum{
    padding: 4px;
  }
  .v-btn-toggle{
    margin:16px;
  }
  .pcOnly{
    display: none;
  }

}

body{
  background: #F5F5F5;
}
.v-btn--active::before{
   opacity:0 !important;
}

.productContainer {
  max-height: calc(100vh - 100px);
  overflow-y: auto;
  padding: 8px;
}

</style>